import { Component, Input } from '@angular/core';

@Component({
  selector: 'u-home-project-closed',
  templateUrl: './home-project-closed.component.html',
  styleUrls: ['./home-project-closed.component.scss']
})
export class HomeProjectClosedComponent {
  @Input() title: string = 'Project Closure Notice';
  @Input() closingDate: string = '';
  @Input() contactEmail: string = 'support@example.com';
}